import React, { useRef } from 'react'
import styles from './CopyLink.module.scss'
import { Button } from 'components/Button/Button'

type Props = {
    link: string;
}

export function CopyLink(props: Props) {
    const linkRef = useRef(null);

    function copyLink() {
        // Select the text inside the input element
        linkRef.current.select();
        // Copy the selected text to the clipboard
        document.execCommand('copy');
        // Deselect the input element
        window.getSelection().removeAllRanges();
    }

    return (
        <div className={styles['wrapper']}>
            <input
                type="text"
                readOnly
                value={props.link}
                ref={linkRef}
                className={styles['field']}
            />
            <Button
                size='s'
                type='light'
                stretch={false}
                onClick={copyLink}
            >
                Copy link
            </Button>
        </div>
    );
}

